import { defineComponent as _defineComponent } from 'vue'
import CurrencyValue from '@/components/CurrencyValue.vue';
import TwoFactorAuthModal from '@/components/modals/TwoFactorAuthModal.vue';
import StatusPlan from '@/components/StatusPlanComponent.vue';
import Tooltip from '@/components/Tooltip.vue';
import { LoadingModalInjection, TwoFactorAuthModalInjection } from '@/infra/constants/injections';
import LoggedAdminStorage from '@/infra/local_storage/logged_admin_storage';
import { AdminUser } from '@/models/admins/admin_model';
import { Permission } from '@/models/admins/permission_model';
import { Resource } from '@/models/admins/resources_enum';
import { BasketPlan } from '@/models/basket_plans/basket_plan_model';
import { BranchAddresses } from '@/models/branch_addresses_model';
import router, { routes } from '@/router';
import { useCreateBasketPlanStore } from '@/stores/basket_plans/create_basket_plan_store';
import FormatUtils from '@/utils/format_utils';
import { getCurrentInstance, inject, ref, Ref } from 'vue';
import BasketPlanStatus from '../BasketPlanStatus.vue';
import CardBlob from '../CardBlob.vue';
import ContextMenu from '../ContextMenu.vue';
import LoadingModal from '../modals/LoadingModal.vue';
import RenewBasketPlanModal from '../modals/RenewBasketPlanModal.vue';
import UserCountComponent from '../UserCountComponent.vue';

const textEllipsisSize = 14;


export default /*@__PURE__*/_defineComponent({
  __name: 'BasketPlanCard',
  props: {
    basketPlan: { type: Object, required: true },
    hideControls: { type: Boolean, required: false }
  },
  emits: ["change-page", "update", "remove", "request-renew"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const thisInstance = getCurrentInstance();

const props = __props;

const emit = __emit;

const renewBasketPlanModal = ref<InstanceType<typeof RenewBasketPlanModal>>();
const twoFactorAuthModal = inject<Ref<InstanceType<typeof TwoFactorAuthModal>>>(TwoFactorAuthModalInjection);
const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>>>(LoadingModalInjection);
const createBasketPlanStore = useCreateBasketPlanStore;

async function renew() {
  try {
    loadingModal?.value?.open({ zIndex: 1000 });
    await createBasketPlanStore.fetchBranches({
      deliveryAreaId: props.basketPlan.getDeliveryAreaId(),
    });
    const branchAddresses = createBasketPlanStore.branchAddresses;
    const res = await renewBasketPlanModal.value?.open({
      basketPlanId: props.basketPlan.getId(),
      zIndex: 1000,
      branchAddresses: branchAddresses as BranchAddresses,
    });
    if (res?.isSuccess()) {
      createBasketPlanStore.$reset();
      emit('update');
    }
  } finally {
    loadingModal?.value?.close();
  }
}

async function set2FAUser(executeFunction: () => void) {
  if (!LoggedAdminStorage.getIsTwoFactorAuthorized()) {
    await twoFactorAuthModal?.value?.open({
      user: LoggedAdminStorage.getUser() as AdminUser,
      zIndex: 1000,
    });
  }
  if (LoggedAdminStorage.getIsTwoFactorAuthorized()) executeFunction();
}


const __returned__ = { thisInstance, props, emit, renewBasketPlanModal, twoFactorAuthModal, loadingModal, createBasketPlanStore, renew, set2FAUser, textEllipsisSize, CurrencyValue, StatusPlan, Tooltip, get LoggedAdminStorage() { return LoggedAdminStorage }, get Permission() { return Permission }, get Resource() { return Resource }, get router() { return router }, get routes() { return routes }, get FormatUtils() { return FormatUtils }, BasketPlanStatus, CardBlob, ContextMenu, RenewBasketPlanModal, UserCountComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})